module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (typeof _vm.last_call != 'undefined') ? _c('span', [_c('p', [_vm._v("\n        Le " + _vm._s(_vm._f("moment")(_vm.last_call.ended_at, 'L')) + "\n        "), (_vm.moment(_vm.last_call.ended_at).format('H') !== '0') ? _c('span', {
    staticClass: "timeline-date text-muted"
  }, [_c('small', [_vm._v(" à " + _vm._s(_vm._f("moment")(_vm.last_call.ended_at, 'H')) + "h")])]) : _vm._e()]), _vm._v(" "), _c('timeline-call-widget', {
    attrs: {
      "call": _vm.last_call
    }
  })], 1) : _c('span', [_c('p', [_vm._v("Jamais appelé")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bff4858"}!./~/vue-loader/lib/selector.js?type=template&index=0!./libs/@db2b/keystone/components/Widgets/Calls/LastCall.vue
// module id = 669
// module chunks = 1